import { fetchDataAndProceed } from '../../config/utils';
import { METHOD_TYPES } from '../../config/constants';

export const getFiltersData = (callback) => {
    return fetchDataAndProceed('/admin/v1/chatLogs/filters', METHOD_TYPES.GET, {}, callback);
};


// WEBPACK FOOTER //
// ./src/data/redux/filter_details/api.js